<template>
  <div id="pdaMain">
    <el-row>
      <el-col :span="24"
              class="titleLine">
        <el-breadcrumb separator-class="el-icon-arrow-right"
                       class="titleLine1">
          <el-breadcrumb-item>停车场</el-breadcrumb-item>
          <el-breadcrumb-item>路侧场库设置</el-breadcrumb-item>
          <el-breadcrumb-item>设备账号管理</el-breadcrumb-item>
        </el-breadcrumb>
      </el-col>
    </el-row>
    <el-row>
      <el-form :inline="true"
               class="demo-form-inline">
        <el-row>
          <el-col :span="22">
            <el-form-item label="客户名称::"
                          style="margin-bottom: 10px;">
              <el-select v-model="selCustID"
                         filterable
                         clearable
                         placeholder="所有客户">
                <el-option v-for="item in choiceCusts"
                           :key="item.fCustID"
                           :label="item.unionName"
                           :value="item.fCustID">
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="场库名称::">
              <el-select v-model="selParkID"
                         filterable
                         clearable
                         placeholder="请选择场库">
                <el-option v-for="item in parkList"
                           :key="item.fParkID"
                           :label="item.fParkName"
                           :value="item.fParkID">
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="设备账号::">
              <el-input placeholder="请输设备账号"
                        v-model="queryfDevAccNo"
                        class="input-with-select">
              </el-input>
            </el-form-item>
            <el-form-item>
              <el-button type="primary"
                         icon="el-icon-search"
                         size="small"
                         @click="bindQuery">查询</el-button>
            </el-form-item>
          </el-col>
          <el-col :span="2"
                  class="searchRowAdd">
            <el-button type="primary"
                       size="small"
                       @click="addNewPDA"
                       v-if="is_edit">新增手持机</el-button>
          </el-col>
        </el-row>
      </el-form>
    </el-row>
    <el-row>
      <el-table :data="pdaList"
                border
                highlight-current-row
                style="width: 100%"
                v-loading="loading"
                :height="tableHeight"
                ref="singleTable">
        <el-table-column type="index"
                         width="50"
                         label="序号"
                         align="right"
                         :index="indexMethod">
        </el-table-column>
        <el-table-column prop="fCustNo"
                         width="80"
                         label="客户编号">
        </el-table-column>
        <el-table-column prop="fCustName"
                         width="160"
                         label="客户名称">
        </el-table-column>
        <el-table-column prop="fParkNo"
                         width="80"
                         label="场库编号">
        </el-table-column>
        <el-table-column prop="fParkName"
                         width="160"
                         label="场库名称">
        </el-table-column>
        <el-table-column prop="fDevAccNo"
                         label="设备帐号">
        </el-table-column>
        <el-table-column prop="fDevTypeName"
                         label="设备类型">
        </el-table-column>
        <el-table-column prop="fVersion"
                         width="100"
                         label="设备版本">
        </el-table-column>
        <!-- <el-table-column prop="fDateBegName"
                         width="100"
                         label="起始时间">
        </el-table-column>
        <el-table-column prop="fDateEndName"
                         width="100"
                         label="结束时间">
        </el-table-column> -->
        <el-table-column prop="fActTimeName"
                         width="100"
                         label="心跳时间">
        </el-table-column>
        <el-table-column prop="fStatusName"
                         label="状态">
        </el-table-column>
        <el-table-column prop="fLedID"
                         label="LED设备ID">
        </el-table-column>
        <el-table-column prop="fRemark"
                         label="备注">
        </el-table-column>
        <el-table-column fixed="right"
                         align="center"
                         label="操作"
                         width="350">
          <template slot-scope="scope">
            <el-button @click="viewPDA(scope.row)"
                       type="success"
                       size="mini">查看</el-button>
            <el-button size="mini"
                       type="warning"
                       v-if="is_edit"
                       @click="editPDAClient(scope.$index, scope.row)">编辑</el-button>
            <el-button size="mini"
                       type="info"
                       v-if="is_edit"
                       @click="editPDAPwdClient(scope.$index, scope.row)">修改密码</el-button>
            <el-button size="mini"
                       type="danger"
                       v-if="is_del"
                       @click="deletePDAClient(scope.$index, scope.row)">删除</el-button>
          </template>
        </el-table-column>
      </el-table>
    </el-row>
    <el-row class="pagination">
      <el-col :span="24">
        <div class="block">
          <span class="demonstration"></span>
          <el-pagination background
                         @size-change="handleSizeChange"
                         :current-page.sync="pageIndex"
                         @current-change="handlePage"
                         :page-size="pageSize"
                         :page-sizes="[10, 20, 50, 100]"
                         layout="total,sizes, prev, pager, next, jumper"
                         :total="total"
                         v-if="total>0">
          </el-pagination>
        </div>
      </el-col>
    </el-row>
    <el-dialog :title="titleMap[curRowInfo.op]"
               top="7vh"
               width="40%"
               v-dialogDrag
               :visible.sync="editOrDetailVisible">
      <el-form :model="curRowInfo"
               :rules="rules"
               ref="ruleForm"
               label-width="100px">
        <el-row class="margintop5">
          <el-col :span="12">
            <el-form-item label="客户名称::"
                          prop="fCustID">
              <el-select v-model="curRowInfo.fCustID"
                         @change="setPark($event,false)"
                         filterable
                         :disabled="!curRowInfo.isEdit"
                         style="width:100%"
                         placeholder="请选择客户">
                <el-option v-for="item in choiceCusts"
                           :key="item.fCustID"
                           :label="item.unionName"
                           :value="item.fCustID">
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="场库名称::"
                          prop="fParkID">
              <el-select v-model="curRowInfo.fParkID"
                         filterable
                         @change="setPlace($event)"
                         :disabled="!curRowInfo.isEdit"
                         style="width:100%"
                         placeholder="请选择场库">
                <el-option v-for="item in parks"
                           :key="item.fParkID"
                           :label="item.fParkName"
                           :value="item.fParkID">
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row class="margintop5">
          <el-col :span="12">
            <el-form-item label="设备账号::"
                          prop="fDevAccNo">
              <el-input v-model="curRowInfo.fDevAccNo"
                        :disabled="!curRowInfo.isEdit||curRowInfo.op=='edit'"
                        placeholder="请填写设备账号"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="设备密码::"
                          prop="fDevAccPwd">
              <el-input v-model="curRowInfo.fDevAccPwd"
                        type="password"
                        :disabled="!curRowInfo.isEdit||curRowInfo.op=='edit'"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row class="margintop5">
          <el-col :span="12">
            <el-form-item label="设备类型::"
                          prop="fDevTypeID">
              <el-select v-model="curRowInfo.fDevTypeID"
                         filterable
                         style="width:100%"
                         placeholder="请选择设备类型"
                         :disabled="!curRowInfo.isEdit"
                         class="pdaInput">
                <el-option v-for="item in devTypes"
                           :key="item.value"
                           :label="item.text"
                           :value="item.value">
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item label="LED设备ID::"
                          prop="fLedID">
              <el-input v-model="curRowInfo.fLedID"
                        :disabled="!curRowInfo.isEdit"
                        placeholder="请填写LED设备ID"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="LED显示标题::"
                          prop="fLedTitle">
              <el-input v-model="curRowInfo.fLedTitle"
                        :disabled="!curRowInfo.isEdit"
                        placeholder="请填写LED显示标题"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row class="margintop5">
          <el-col :span="12">
            <el-form-item label="联系人::"
                          prop="fLinkman">
              <el-input v-model="curRowInfo.fLinkman"
                        :disabled="!curRowInfo.isEdit"
                        placeholder="请填写联系人"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="联系电话::"
                          prop="fLinkPhone">
              <el-input v-model="curRowInfo.fLinkPhone"
                        placeholder="请填写联系电话"
                        :disabled="!curRowInfo.isEdit"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row class="margintop5">
          <el-col :span="12">
            <el-form-item label="起始时间::"
                          prop="fDateBeg">
              <el-date-picker v-model="curRowInfo.fDateBeg"
                              type="date"
                              style="width:100%"
                              :disabled="!curRowInfo.isEdit"
                              placeholder="选择起始时间">
              </el-date-picker>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="结束时间::"
                          prop="fDateEnd">
              <el-date-picker v-model="curRowInfo.fDateEnd"
                              type="date"
                              style="width:100%"
                              :disabled="!curRowInfo.isEdit"
                              placeholder="选择结束时间">
              </el-date-picker>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row style="height: 200px;overflow-y: auto">
          <el-col :span="24">
            <el-form-item label="车位设置::"
                          prop="fPlaceList">
              <el-checkbox :indeterminate="isIndeterminate"
                           v-model="checkAll"
                           :disabled="!curRowInfo.isEdit"
                           @change="handleCheckAllChange">全选</el-checkbox>
              <div style="margin: 5px 0;"></div>
              <el-checkbox-group v-model="chkPlaces"
                                 @change="handleCheckedCitiesChange">
                <el-checkbox v-for="place in parkPlaces"
                             :label="place"
                             :key="place.fBigRowID"
                             :disabled="!curRowInfo.isEdit">{{place.fPlaceNo}}-{{place.fAreaName}}</el-checkbox>
              </el-checkbox-group>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row class="fRemark_row margintop5">
          <el-col :span="24">
            <el-form-item label="备注::"
                          prop="fRemark">
              <el-input type="textarea"
                        v-model="curRowInfo.fRemark"
                        :disabled="!curRowInfo.isEdit"
                        height="150px"
                        placeholder="请填写备注"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row class="margintop5">
          <el-col :span="24">
            <el-form-item label="启用状态::"
                          prop="fStatus">
              <el-radio-group v-model="curRowInfo.fStatus"
                              :disabled="!curRowInfo.isEdit">
                <el-radio label="0">禁用</el-radio>
                <el-radio label="1">启用</el-radio>
              </el-radio-group>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <div class="dialog-footer"
           slot="footer">
        <el-button type="primary"
                   @click="submitForm('ruleForm')"
                   v-if="curRowInfo.isEdit">保存</el-button>
        <el-button @click="editOrDetailVisible = false">取消</el-button>
      </div>
    </el-dialog>
    <el-dialog title="修改密码"
               :visible.sync="editPwdVisible"
               v-dialogDrag
               top="7vh"
               left="0vh"
               width="30%">
      <el-form :model="editPDAPwdObj"
               :rules="editPwdRules"
               ref="formPwd"
               label-width="100px">
        <el-form-item class="margintop5"
                      label="设备账号::"
                      prop="fDevAccNo">
          <el-input v-model="editPDAPwdObj.fDevAccNo"
                    autocomplete="off"
                    :disabled="true"></el-input>
        </el-form-item>
        <el-form-item class="margintop5"
                      label="原密码::"
                      prop="fDevAccPwd">
          <el-input type="password"
                    v-model="editPDAPwdObj.fDevAccPwd"
                    autocomplete="off"></el-input>
        </el-form-item>
        <el-form-item class="margintop5"
                      label="新密码::"
                      prop="fNewDevAccPwd">
          <el-input type="password"
                    v-model="editPDAPwdObj.fNewDevAccPwd"
                    autocomplete="off"></el-input>
        </el-form-item>
        <el-form-item class="margintop5"
                      label="确认密码::"
                      prop="checkPass">
          <el-input type="password"
                    v-model="editPDAPwdObj.checkPass"
                    autocomplete="off"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer"
           class="dialog-footer"
           style="text-align:right">
        <el-button type="primary"
                   @click="submitPwdForm('formPwd')">保存</el-button>
        <el-button @click="editPwdVisible = false">取消</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import * as api from '../../api/park'
import { mapActions } from 'vuex'
export default {
  name: 'pdaMain',
  data () {
    var validatePass2 = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('请再次输入密码'))
      } else if (value !== this.editPDAPwdObj.fNewDevAccPwd) {
        callback(new Error('两次输入密码不一致!'))
      } else {
        callback()
      }
    }
    // var validateDevAccNo = (rule, value, callback) => {
    //   if (!/^[a-zA-Z0-9]+$/.test(value)) {
    //     callback(new Error('请输入字母或数字'))
    //   } else {
    //     callback()
    //   }
    // }
    return {
      isIndeterminate: true,
      chkPlaces: [],
      checkAll: false,
      loading: false,
      parkPlaces: [],
      selectedParkPlaces: [],
      devTypes: [],
      editPDAPwdObj: {
        fDevAccID: '',
        fCustID: '',
        fParkID: '',
        fDevAccNo: '',
        fDevAccPwd: '',
        fNewDevAccPwd: '',
        checkPass: ''
      },
      curRowInfo: {
        fDevAccID: 0,
        fCustNo: '',
        fCustID: '',
        fParkID: '',
        fDevAccNo: '',
        fDevAccPwd: '666666',
        fLinkman: '',
        fLinkPhone: '',
        fDevTypeID: '0',
        fDateBeg: '',
        fDateEnd: '',
        fStatus: '1',
        fRemark: '',
        fPlaceListArr: [],
        fPlaceList: '',
        fLedID: '',
        fLedTitle: '',
        op: 'add'
      },
      editPwdRules: {
        fDevAccPwd: [
          { required: true, message: '请输入用户密码', trigger: 'blur' },
          { min: 6, max: 60, message: '长度为6到60个字符', trigger: 'blur' }
        ],
        fNewDevAccPwd: [
          { required: true, message: '请输入用户密码', trigger: 'blur' },
          { min: 6, max: 60, message: '长度为6到60个字符', trigger: 'blur' }
        ],
        checkPass: [
          { required: true, message: '请再次输入用户密码', trigger: 'blur' },
          { validator: validatePass2, trigger: 'blur' }
        ]
      },
      rules: {
        fCustID: [
          { required: true, message: '请选择客户', trigger: 'change' }
        ],
        fParkID: [
          { required: true, message: '请选择场库', trigger: 'change' }
        ],
        fDevAccNo: [
          { required: true, message: '请输入设备账号', trigger: 'blur' },
          // { validator: validateDevAccNo, trigger: 'blur' },
          { min: 6, max: 16, message: '长度为6到16个字符', trigger: 'blur' }

        ],
        fDevAccPwd: [
          { required: true, message: '请输入设备密码', trigger: 'blur' },
          { min: 6, max: 60, message: '长度为6到60个字符', trigger: 'blur' }
        ],
        fDateBeg: [
          { required: true, message: '请输入起始时间', trigger: 'blur' }
        ],
        fDateEnd: [
          { required: true, message: '请输入结束时间', trigger: 'blur' }
        ]
      },
      titleMap: {
        add: '新增设备账号',
        edit: '编辑设备账号',
        view: '查看设备账号'
      },
      parkList: [],
      parks: [],
      editOrDetailVisible: false,
      editPwdVisible: false,
      detailTitle: '',
      pdaList: [],
      selfParkID: '',
      is_edit: true,
      is_del: true,
      queryParkName: '',
      queryParkNo: '',
      queryfDevAccNo: '',
      selParkID: '',
      selCustID: '',
      choiceCusts: [],
      tableHeight: 0,
      pageSize: 20,
      pageIndex: 1,
      total: 0
    }
  },
  methods: {
    ...mapActions([
      'getCustByGroup', 'getParkList', 'getCurrentUserPers'
    ]),
    handleCheckAllChange (val) {
      this.chkPlaces = val ? this.parkPlaces : []
      this.isIndeterminate = false
    },
    handleCheckedCitiesChange (value) {
      let checkedCount = value.length
      this.checkAll = checkedCount === this.parkPlaces.length
      this.isIndeterminate = checkedCount > 0 && checkedCount < this.parkPlaces.length
    },
    submitPwdForm (formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          api.editPDAPwd(this.editPDAPwdObj).then(res => {
            if (res && res.data) {
              let { status, data } = res
              if (status !== 200) {
                this.$message({
                  type: 'success',
                  message: '用户操作失败'
                })
              } else {
                if (!data.IsOk) {
                  this.$message({
                    type: 'success',
                    message: data.Msg
                  })
                } else {
                  this.editPwdVisible = false
                  this.$message({
                    type: 'success',
                    message: '修改密码成功'
                  })
                }
              }
            }
          })
        }
      })
    },
    submitForm (formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          let tmpCust = this.choiceCusts.filter(item => {
            if (item.fCustID === this.curRowInfo.fCustID) { return item }
          })
          if (tmpCust && tmpCust.length > 0) {
            this.curRowInfo.fCustNo = tmpCust[0].fCustNo
          } else {
            return false
          }
          this.curRowInfo.fPlaceListArr = this.chkPlaces
          if (this.curRowInfo.fDateEnd instanceof Date) {
            this.curRowInfo.fDateEnd = this.$dateFormat(this.curRowInfo.fDateEnd, 'yyyy-MM-dd')
          }

          if (this.curRowInfo.fDateBeg instanceof Date) {
            this.curRowInfo.fDateBeg = this.$dateFormat(this.curRowInfo.fDateBeg, 'yyyy-MM-dd')
          }
          api.saveRoadSidePDA(this.curRowInfo).then(res => {
            if (res && res.data) {
              var data = res.data
              if (data.IsOk) {
                this.editOrDetailVisible = false
                this.initData()
                this.$message({
                  type: 'success',
                  message: '保存成功!'
                })
              } else {
                this.$message.error(data.Msg)
              }
            }
          })
        }
      })
    },
    addNewPDA () {
      this.setDefault()
      setTimeout(() => {
        if (this.$refs['ruleForm']) {
          this.$refs['ruleForm'].clearValidate()
        }
      }, 50)
      this.detailTitle = '新增设备'
      this.curRowInfo.fDevTypeID = this.devTypes[0].value
      this.curRowInfo.isEdit = true
      this.editOrDetailVisible = true
      this.curRowInfo.op = 'add'
      this.curRowInfo.fStatus = '1'
      this.parks = []
    },
    viewPDA (row) {
      this.curRowInfo.isEdit = false
      if (row && row !== null && typeof (row) !== 'undefined') {
        this.updatePDA(row, false, 'view')
      }
    },
    editPDAPwdClient (index, row) {
      this.editPwdVisible = true
      for (let key in this.editPDAPwdObj) {
        this.editPDAPwdObj[key] = ''
      }
      if (this.$refs['formPwd']) {
        this.$refs['formPwd'].resetFields()
      }
      if (row && row !== null && typeof (row) !== 'undefined') {
        this.editPDAPwdObj.fDevAccID = row.fDevAccID
        this.editPDAPwdObj.fCustID = row.fCustID
        this.editPDAPwdObj.fParkID = row.fParkID
        this.editPDAPwdObj.fDevAccNo = row.fDevAccNo
      }
    },
    updatePDA (row, isEdit, op) {
      if (this.$refs.ruleForm) {
        this.$refs.ruleForm.clearValidate()
      }
      this.setDefault()
      for (let key in this.curRowInfo) {
        this.curRowInfo[key] = row[key]
      }
      this.curRowInfo.isEdit = isEdit
      this.curRowInfo.op = op
      this.editOrDetailVisible = true
      this.curRowInfo.fDateBeg = row.fDateBegName
      this.curRowInfo.fDateEnd = row.fDateEndName
      this.curRowInfo.fPlaceList = row.fPlaceList
      this.curRowInfo.fDevAccID = row.fDevAccID
      this.setPark(this.curRowInfo.fCustID, true)
      this.curRowInfo.fCustID = row.fCustID
      this.curRowInfo.fParkID = row.fParkID
      this.setPlace(this.curRowInfo.fParkID, true)
    },
    editPDAClient (index, row) {
      this.curRowInfo.isEdit = true
      if (row && row !== null && typeof (row) !== 'undefined') {
        this.updatePDA(row, true, 'edit')
      }
    },
    deletePDAClient (index, row) {
      this.$confirm('删除该客户[' + row.fCustName + ']的场库[' + row.fParkName + ']的手持机, 是否继续?', '提示', {
        cancelButtonText: '取消',
        confirmButtonText: '确定',
        type: 'warning'
      }).then(() => {
        api.deleteRoadSidePDA(row).then(res => {
          if (res && res.data) {
            var data = res.data
            if (data.IsOk) {
              this.$message({
                type: 'success',
                message: '删除成功!'
              })
              this.initData()
            } else {
              this.$message.error(data.Msg)
            }
          }
        })
      }).catch(() => { })
    },
    changeCust (val) {
      api.getParkList({ fCustID: val }).then(res => {
        if (res && res.data) {
          var data = res.data
          if (data.IsOk) {
            this.parkList = data.Data || []
            if (this.parkList && this.parkList.length > 0) {
              this.selParkID = this.parkList[0].fParkID
              this.initData()
            }
          } else {
            this.$message.error('提示：加载场库列表失败')
          }
        }
      })
    },
    setDefault () {
      for (let key in this.curRowInfo) {
        this.curRowInfo[key] = ''
      }
      this.curRowInfo.fDevAccPwd = '666666'
      this.parkPlaces.splice(0, this.parkPlaces.length)
    },
    bindQuery () {
      this.initData()
    },
    handleSizeChange (value) {
      this.pageSize = value
      this.initData()
    },
    handlePage (index) {
      this.pageIndex = index
      this.initData()
    },
    indexMethod (index) {
      return this.pageSize * (this.pageIndex - 1) + index + 1
    },
    setPark (val, isedit) {
      this.parks = []
      this.parkPlaces.splice(0, this.chkPlaces.length)
      this.chkPlaces.splice(0, this.chkPlaces.length)
      this.getParkList({ fCustID: val }).then(res => {
        if (res && res.data) {
          let { status, data } = res
          if (status === 200) {
            if (data.IsOk) {
              this.parks = data.Data || []
              if (!isedit) {
                if (this.parks && this.parks.length > 0) {
                  this.curRowInfo.fParkID = this.parks[0].fParkID
                }
              }
            }
          }
        }
      })
    },
    setPlace (val, isedit) {
      var param = {}
      param.pageIndex = 1
      param.pageSize = 999999
      param.fCustID = this.curRowInfo.fCustID
      param.fParkID = this.curRowInfo.fParkID
      param.fAreaName = ''
      param.fPlaceNo = ''
      if (param.fCustID !== '' && param.fParkID !== '') {
        api.parkPlaceList(param).then(res => {
          if (res && res.data) {
            var data = res.data
            if (data.IsOk) {
              this.parkPlaces = data.Data.data || []
              if (this.curRowInfo.fPlaceList && this.curRowInfo.fPlaceList.length > 0) {
                var placeArr = this.curRowInfo.fPlaceList.split(' ')
                if (placeArr && placeArr.length > 0) {
                  this.chkPlaces.splice(0, this.chkPlaces.length)
                  for (var j = 0; j < placeArr.length; j++) {
                    let tmp = this.parkPlaces.filter(item => {
                      if (item.fPlaceNo === placeArr[j]) { return item }
                    })
                    if (tmp && tmp[0]) {
                      this.chkPlaces.push(tmp[0])
                    }
                  }
                }
              }
            } else {
              this.$message.error('提示：加载场库车位列表失败')
            }
          }
        })
      }
    },
    initData () {
      let param = {}
      param['fCustID'] = this.selCustID
      param['fParkID'] = this.selParkID
      param['fDevAccNo'] = this.queryfDevAccNo
      param.pageSize = this.pageSize
      param.pageIndex = this.pageIndex
      this.pdaList = []
      this.loading = true
      api.getPdaByQuery(param).then(res => {
        this.loading = false
        if (res && res.data) {
          let { status, data } = res
          if (status === 200) {
            if (data.IsOk) {
              let tmpParks = []
              Object.assign(tmpParks, data.Data.rows)
              this.pdaList = tmpParks
              this.total = data.Data.total
            }
          }
        }
      })
    },
    setTableHeight (obj) {
      let clientHeight = obj.getRJPageSize.getRJPageSize()[3] - 25 - 230
      obj.tableHeight = clientHeight
    }
  },
  watch: {
    selCustID () {
      api.getParkList({ fCustID: this.selCustID }).then(res => {
        if (res && res.data) {
          var data = res.data
          if (data.IsOk) {
            this.parkList = data.Data || []
            // if (this.parkList && this.parkList.length > 0) {
            //   this.selParkID = this.parkList[0].fParkID
            //   this.initData()
            // }
          } else {
            this.$message.error('提示：加载场库列表失败')
          }
        }
      })
    },
    'curRowInfo.fParkID' (newValue, oldValue) {
      this.setPlace()
    }
  },
  created () {
    this.getCurrentUserPers({ perTypeId: 82000 }).then(res => {
      if (res && res.data) {
        var data = res.data
        if (data.IsOk) {
          if (data.Data) {
            this.is_edit = data.Data.data.is_edit
            this.is_del = data.Data.data.is_del
          }
        } else {
          this.$message.error('提示：加载当前用户权限信息失败')
        }
      }
    })
  },
  mounted () {
    window.onresize = () => {
      this.setTableHeight(this)
    }
    this.getCustByGroup({ fCustTypeID: 1 }).then(res => {
      if (res && res.data) {
        let { status, data } = res
        if (status === 200) {
          if (data.IsOk) {
            let custs = []
            let all = {}
            all['fCustID'] = ' '
            all['unionName'] = '所有客户'
            Object.assign(custs, data.Data)
            this.choiceCusts = custs
            // if (this.choiceCusts && this.choiceCusts.length > 0) {
            //   this.selCustID = this.choiceCusts[0].fCustID
            // }
          }
        }
      }
    })
    api.roadSideDevTypeList().then(res => {
      if (res && res.data) {
        let { status, data } = res
        if (status === 200) {
          if (data.IsOk) {
            this.devTypes = data.Data || []
          }
        }
      }
    })
    this.initData()
  },
  updated () {
    this.setTableHeight(this)
  }
}
</script>

<style>
#pdaMain .el-dialog__headerbtn {
  top: 10px;
  font-size: 20px;
}
#pdaMain .el-dialog__title {
  color: white;
}
#pdaMain .el-dialog__header {
  background-color: #337ab7;
  padding: 10px;
}
#pdaMain .el-dialog__body {
  padding: 20px 20px 0px 20px;
}
#pdaMain .is-disabled .el-input__inner,
#pdaMain .is-disabled .el-textarea__inner {
  color: #606266;
}
.pdaMainEditOrDetail .el-dialog__headerbtn {
  top: 10px;
  font-size: 20px;
}
.pdaMainEditOrDetail .el-dialog__title {
  color: white;
}
.pdaMainEditOrDetail .el-dialog__header {
  background-color: #337ab7;
  padding: 10px;
}
.pdaMainEditOrDetail .el-dialog__body {
  padding: 0px;
}
.pdaMainEditOrDetail .myPDALableClass {
  text-align: right;
  float: left;
  color: #606266;
  line-height: 30px;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  /*font-family: 宋体;*/
  font-size: 13px;
}

.pdaMainEditOrDetail .el-radio {
  line-height: 2px;
}
.pdaMainEditOrDetail .is-disabled .el-input__inner,
.pdaMainEditOrDetail .is-disabled .el-textarea__inner {
  color: #606266;
}

#pdaMain .warning-row {
  color: chocolate;
}
#pdaMain .fRemark_row .el-form-item__content {
  height: initial;
}
</style>
<style scoped>
.pagination {
  text-align: right;
  padding-top: 5px;
}
.dialog-video-wrapper .el-dialog__body {
  padding: 5px;
}
.dialog-footer {
  text-align: right;
  padding: 20px;
}
.searchRowAdd {
  text-align: right;
}
</style>



// WEBPACK FOOTER //
// src/view/roadSidePark/pdaMain.vue